import { AxiosPromise, AxiosStatic } from "axios";
import { ClientPayment } from "../types/ClientPayment";

export const findPaymentById =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (paymentId: string): AxiosPromise<ClientPayment> =>
    await appAxios.get(`${serverURL}/payments-v2/${paymentId}`, {
      withCredentials: true,
    });
